/**
 * Slice Redux pour les notes
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NoteDevoir, NoteExamen } from '../../types';

interface NoteState {
  notesDevoirs: NoteDevoir[];
  notesExamens: NoteExamen[];
  loading: boolean;
  error: string | null;
}

const initialState: NoteState = {
  notesDevoirs: [],
  notesExamens: [],
  loading: false,
  error: null,
};

const noteSlice = createSlice({
  name: 'notes',
  initialState,
  reducers: {
    setNotesDevoirs: (state, action: PayloadAction<NoteDevoir[]>) => {
      state.notesDevoirs = action.payload;
    },
    setNotesExamens: (state, action: PayloadAction<NoteExamen[]>) => {
      state.notesExamens = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setNotesDevoirs,
  setNotesExamens,
  setLoading,
  setError,
  clearError,
} = noteSlice.actions;

export default noteSlice.reducer;
